export default "__VITE_ASSET__BMIlYSGM__"